import React from 'react';
import { List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { components } from 'react-select';
import _ from 'lodash';

const MenuList = ({ children, selectProps, handleOnFocusOption, allowScrollToIndex, ...props }) => {
  const rows = children;

  // setup a cache for the cellmeasure that will handle dynamic row height
  const cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 35,
  });

  const rowRenderer = ({ key, index, parent, style }) => (
    <CellMeasurer cache={cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
      {({ registerChild }) => (
        <div ref={registerChild} style={style} onMouseOver={() => props.enableScrollToIndex && props.enableScrollToIndex(false)}>
          {rows[index]}
        </div>
      )}
    </CellMeasurer>
  );

  const controlWrapperEl = selectProps.selectRef.current.select.controlRef;
  const controlWrapperWidth = controlWrapperEl.offsetWidth - 2; /* 2px = accounting for border width */
  const height = document.documentElement.clientHeight - controlWrapperEl.getBoundingClientRect().top - 70;

  // DISPLAY A MESSAGE IF THERE IS NO ROWS TO SHOW
  if (!rows.length) {
    const menuHeaderStyle = {
      padding: '16px',
      color: '#999999',
    };
    return (
      <components.MenuList {...props}>
        <div style={menuHeaderStyle}>No results found</div>
      </components.MenuList>
    );
  }

  const scrollToIndex = () => {
    handleOnFocusOption(children);
    return _.findLastIndex(children, child => child.props.isFocused);
  };

  const getTypeOverrides = () => {
    if (allowScrollToIndex) {
      return {
        scrollToIndex: scrollToIndex(),
      };
    }
  };

  return (
    <List
      className="popout-include"
      width={controlWrapperWidth}
      height={rows.length ? (height < 200 ? height : 200) : 35} // 200PX is the max height for the dropdown menu list
      rowHeight={cache.rowHeight}
      rowCount={rows.length || 0}
      rowRenderer={rowRenderer}
      overscanRowCount={0}
      autoHeight={rows.length < 5 && height > 130}
      {...getTypeOverrides()}
    />
  );
};

export default MenuList;
